"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabList_exports = {};
__export(TabList_exports, {
  TabList: () => TabList,
  isTabList: () => isTabList
});
module.exports = __toCommonJS(TabList_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_Slot = require("./Slot");
function TabList(param) {
  var { asChild, ...props } = param;
  var Comp = asChild ? import_Slot.Slot : "nav";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Comp, {
    ...props
  });
}
function isTabList(child) {
  return child.type === TabList;
}
//# sourceMappingURL=TabList.js.map
